import { UserVeriffVerificationStatus } from './model/UserVeriffVerificationStatus';
import { ApiResponseError } from '../ApiResponseError';

export const getUserVeriffVerificationStatus = async (sessionId: string): Promise<UserVeriffVerificationStatus> => {
  const options: RequestInit = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  };

  const endpoint = `${process.env.VERIFF_SERVICE_BASE_URL}/api/verification?sessionId=${sessionId}`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as UserVeriffVerificationStatus;
};

export const getUserVeriffVerificationStatusLightRegisteredUser = async (
  sessionId: string,
  userId: string,
): Promise<UserVeriffVerificationStatus> => {
  const options: RequestInit = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${userId}`,
    },
    credentials: 'include',
  };

  const endpoint = `${process.env.VERIFF_SERVICE_BASE_URL}/light-user/api/verification?sessionId=${sessionId}`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as UserVeriffVerificationStatus;
};
